/* eslint-disable no-mixed-operators */
import React, { useState } from "react";
import privacyIcon from "../../assests/page/privacy_tip.svg";
import PaymentProcess from "../popups/paymentProcess";
import dropdownIcon from "../../assests/page/contact-dropdown.svg";
import arrowUp from "../../assests/page/contact-arrow-up.svg";
import selectBankCircle from "../../assests/page/select-bank-circle.svg";
import selectBankClicked from "../../assests/page/select-bank-clicked.svg";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import fileCopyIcon from "../../assests/page/file-copy.svg";
import documentIcon from "../../assests/page/article.svg";
import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import addGreyIcon from "../../assests/page/add-grey-background.svg";
import addBlueIcon from "../../assests/page/add-blue-background.svg";
import plusGreyIcon from "../../assests/page/add-grey-icon.svg";
import cancelXIcon from "../../assests/page/x-cancel-icon.svg";
import fileIconBlue from "../../assests/page/file-blue-icon-upload.svg";
import pdfFileIconRed from "../../assests/page/pdf-file-icon-red.svg";
import { hashTheString } from "@verified-network/verified-custody";
import useUserStore from "../../store/userSlice";
import { uploadFileToFirebase } from "../../utils/helpers/kyc";
import {
  capitalizeFirstLetter,
  encryptKycString,
  flattenArray,
  formatFileSize,
} from "../../utils/helpers/utils";
import { useTranslation } from "react-i18next";
import { Handle, Position } from "@xyflow/react";
import { progress } from "framer-motion";

export const TermAndConditionOverlay = () => {
  return (
    <p className="terms-and-condition">
      By proceeding, you agree with Verified Wallet{" "}
      <span style={{ color: "#603FF4", cursor: "pointer" }}>T&C</span> and{" "}
      <span style={{ color: "#603FF4", cursor: "pointer" }}>
        Privacy Policy.
      </span>
    </p>
  );
};

export const PrivacyOverlay = () => {
  return (
    <div className="privacy">
      <img alt="Privacy Icon" src={privacyIcon} className="privacy-icon" />
      <p className="privacy-text">Trusted by 10L+ Investors globally</p>
    </div>
  );
};

export const TransactionOverlay = (
  title,
  description,
  time,
  setCustomPopupContent,
  setShowCustomPopup,
) => {
  setCustomPopupContent(
    <PaymentProcess title={title} description={description} time={time} />,
  );
  setShowCustomPopup(true);
};

export const TaxResidencyOverlay = (props) => {
  const { t } = useTranslation();
  const {
    selectedCountry,
    setSelectedCountry,
    searchActive,
    setSearchActive,
    newSearchContent,
    setNewSearchContent,
    countryList,

    setIsCheckboxClicked,
    selectedTin,
    setInputTin,
    inputTin,
    setSelectedTin,
    selectedNoTin,
    setSelectedNoTin,
    setKycQuestionnaire,

    userAddress,
    inputNoTin,
    setInputNoTin,
    isSec,
  } = props;
  return (
    <React.Fragment>
      <p className="verify-kyc-footer-text">{t("kyc.taxResidency")}</p>
      <div className="profile-edit-contact-body">
        <div className="profile-edit-contact-content">
          <div className="profile-edit-contact-input-container">
            <div className="profile-edit-contact-input">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  background: "transparent",
                  border: "1px solid var(--Neutral-100, #eeeef0)",
                }}
                onClick={() => {
                  setSearchActive(!searchActive);
                }}
                className="profile-edit-contact-first-section"
              >
                <div className="profile-edit-contact-selection-icon">
                  {selectedCountry.flag?.length > 0 && (
                    <img
                      onClick={() => {
                        setSearchActive(!searchActive);
                      }}
                      style={{
                        minHeight: "24px",
                        minWidth: "24px",
                      }}
                      alt="Country Flag"
                      src={selectedCountry.flag}
                    />
                  )}
                </div>
                <p
                  style={{ width: "fit-content", cursor: "pointer" }}
                  onClick={() => {
                    setSearchActive(!searchActive);
                  }}
                  className="profile-edit-contact-selection-text"
                >
                  {selectedCountry.name?.length > 0
                    ? selectedCountry.name
                    : `${t("kyc.selectYourTaxResidency")}`}
                </p>

                {searchActive && (
                  <img
                    onClick={() => {
                      setSearchActive(!searchActive);
                    }}
                    alt="Dropdown Icon"
                    src={arrowUp}
                  />
                )}
                {!searchActive && (
                  <img
                    onClick={() => {
                      setSearchActive(!searchActive);
                    }}
                    alt="Dropdown Icon"
                    src={dropdownIcon}
                  />
                )}
              </div>
            </div>
            {searchActive && (
              <>
                {!countryList && <p>{t("common.loading")}...</p>}
                {countryList && countryList?.length > 0 && (
                  <div className="mobille-startup-search-box-container">
                    <div className="mobile-startup-search-box">
                      <img
                        src={searchIcon}
                        alt="Search Icon"
                        className="mobile-search-icon"
                      />
                      <input
                        onInput={(e) => {
                          if (e.target.value === "") {
                            setNewSearchContent(null);
                          } else {
                            setNewSearchContent(
                              countryList?.filter(
                                // eslint-disable-next-line array-callback-return
                                (src) => {
                                  if (
                                    src.name
                                      .toLowerCase()
                                      .includes(e.target.value.toLowerCase())
                                  ) {
                                    src.searched = e.target.value.toLowerCase();
                                    src.nameArray = src.name.split("");
                                    return src;
                                  }
                                },
                              ),
                            );
                          }
                        }}
                        type="text"
                        className="ms-search-box-content"
                        placeholder={t("placeholder.search")}
                      />
                    </div>
                    <div className="mobile-startup-search-content">
                      <div
                        style={
                          props.contentMaxHeight
                            ? {
                                maxHeight: `${props.contentMaxHeight}px`,
                              }
                            : {}
                        }
                        className="ms-search-content-container"
                      >
                        {!newSearchContent &&
                          countryList?.length > 0 &&
                          countryList?.map((src, idx) => (
                            <div
                              key={idx}
                              onClickCapture={() => {
                                setSelectedCountry({
                                  area: src?.phone_code,
                                  flag: src?.flag,
                                  name: src.name,
                                  continent: src.continent,
                                  code: src?.code?.toUpperCase(),
                                });
                                if (src?.code?.toLowerCase() === "ch") {
                                  setIsCheckboxClicked(false);
                                }
                              }}
                              onClick={async () => {
                                setSelectedCountry({
                                  area: src?.phone_code,
                                  flag: src?.flag,
                                  name: src.name,
                                  continent: src.continent,
                                  code: src?.code?.toUpperCase(),
                                });
                                let kycQuestionaire =
                                  JSON.parse(
                                    localStorage.getItem(
                                      `${userAddress?.toLowerCase()}-kyc-aml`,
                                    ),
                                  ) || {};
                                kycQuestionaire[
                                  isSec ? "texResidencySec" : "taxResidency"
                                ] = {
                                  area: src?.phone_code,
                                  flag: src?.flag,
                                  name: src.name,
                                  continent: src.continent,
                                  code: src?.code?.toUpperCase(),
                                };

                                setKycQuestionnaire((prev) =>
                                  isSec
                                    ? {
                                        ...prev,
                                        texResidencySec: {
                                          area: src?.phone_code,
                                          flag: src?.flag,
                                          name: src.name,
                                          continent: src.continent,
                                          code: src?.code?.toUpperCase(),
                                        },
                                      }
                                    : {
                                        ...prev,
                                        taxResidency: {
                                          area: src?.phone_code,
                                          flag: src?.flag,
                                          name: src.name,
                                          continent: src.continent,
                                          code: src?.code?.toUpperCase(),
                                        },
                                      },
                                );
                                localStorage.setItem(
                                  `${userAddress?.toLowerCase()}-kyc-aml`,
                                  JSON.stringify({
                                    ...kycQuestionaire,
                                    lastUpdated: Date.now(),
                                  }),
                                );
                                if (setSearchActive) {
                                  setSearchActive(!searchActive);
                                }
                                setNewSearchContent(null);

                                if (src?.code?.toLowerCase() === "ch") {
                                  setIsCheckboxClicked(false);
                                }
                              }}
                              className="ms-search-content"
                            >
                              <img
                                src={src?.flag}
                                alt="Search Result Icon"
                                className="ms-search-content-icon"
                              />
                              <p className="ms-search-content-text">
                                {src.name}
                              </p>
                            </div>
                          ))}

                        {newSearchContent &&
                          newSearchContent.length > 0 &&
                          newSearchContent.map((src, idx) => (
                            <div
                              key={idx}
                              onClickCapture={() => {
                                setSelectedCountry({
                                  area: src?.phone_code,
                                  flag: src?.flag,
                                  name: src.name,
                                  continent: src.continent,
                                  code: src?.code?.toUpperCase(),
                                });

                                if (src?.code?.toLowerCase() === "ch") {
                                  setIsCheckboxClicked(false);
                                }
                              }}
                              onClick={async () => {
                                setSelectedCountry({
                                  area: src?.phone_code,
                                  flag: src?.flag,
                                  name: src.name,
                                  continent: src.continent,
                                  code: src?.code?.toUpperCase(),
                                });
                                let kycQuestionaire =
                                  JSON.parse(
                                    localStorage.getItem(
                                      `${userAddress?.toLowerCase()}-kyc-aml`,
                                    ),
                                  ) || {};
                                kycQuestionaire[
                                  isSec ? "texResidencySec" : "taxResidency"
                                ] = {
                                  area: src?.phone_code,
                                  flag: src?.flag,
                                  name: src.name,
                                  continent: src.continent,
                                  code: src?.code?.toUpperCase(),
                                };

                                setKycQuestionnaire((prev) =>
                                  isSec
                                    ? {
                                        ...prev,
                                        taxResidencySec: {
                                          area: src?.phone_code,
                                          flag: src?.flag,
                                          name: src.name,
                                          continent: src.continent,
                                          code: src?.code?.toUpperCase(),
                                        },
                                      }
                                    : {
                                        ...prev,
                                        taxResidency: {
                                          area: src?.phone_code,
                                          flag: src?.flag,
                                          name: src.name,
                                          continent: src.continent,
                                          code: src?.code?.toUpperCase(),
                                        },
                                      },
                                );
                                localStorage.setItem(
                                  `${userAddress?.toLowerCase()}-kyc-aml`,
                                  JSON.stringify({
                                    ...kycQuestionaire,
                                    lastUpdated: Date.now(),
                                  }),
                                );
                                if (setSearchActive) {
                                  setSearchActive(!searchActive);
                                }
                                setNewSearchContent(null);

                                if (src?.code?.toLowerCase() === "ch") {
                                  setIsCheckboxClicked(false);
                                }
                              }}
                              className="ms-search-content"
                            >
                              <img
                                src={src?.flag}
                                alt="Search Result Icon"
                                className="ms-search-content-icon"
                              />
                              <p className="ms-search-content-text">
                                {src.nameArray?.length > 0 &&
                                  src.nameArray.map((nm, idx) => (
                                    <>
                                      {!src.searched.includes(
                                        nm.toLowerCase(),
                                      ) && (
                                        <span
                                          key={idx}
                                          style={{
                                            color: "#B6B7C3",
                                          }}
                                        >
                                          {nm}
                                        </span>
                                      )}
                                      {src.searched.includes(
                                        nm.toLowerCase(),
                                      ) && <span key={idx}>{nm}</span>}
                                    </>
                                  ))}
                              </p>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <p className="verify-kyc-footer-text">
        {t("kyc.hasTaxIdentificationNumber")}
      </p>
      <div className="profile-edit-contact-body">
        <div className="select-bank-popup">
          <div className="select-bank-popup-container">
            <div className="select-bank-popup-body">
              <div className="select-bank-popup-body-container">
                <div
                  onClick={async () => {
                    setSelectedTin("yes");
                    let kycQuestionaire =
                      JSON.parse(
                        localStorage.getItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                        ),
                      ) || {};

                    kycQuestionaire[isSec ? "selectedTinSec" : "selectedTin"] =
                      await encryptKycString("yes");

                    setKycQuestionnaire((prev) =>
                      isSec
                        ? {
                            ...prev,
                            selectedTinSec: "yes",
                          }
                        : { ...prev, selectedTin: "yes" },
                    );
                    localStorage.setItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                      JSON.stringify({
                        ...kycQuestionaire,
                        lastUpdated: Date.now(),
                      }),
                    );
                  }}
                  className="select-bank-popup-body-content"
                >
                  <div className="select-bank-popup-body-content-container">
                    <div className="select-bank-popup-body-content-main">
                      <div className="select-bank-popup-body-content-text-container">
                        <p className="select-bank-popup-body-content-text">
                          {t("kyc.yes")}
                        </p>
                      </div>
                      {selectedTin !== "yes" && (
                        <img src={selectBankCircle} alt="Checkbox Icon" />
                      )}
                      {selectedTin === "yes" && (
                        <img src={selectBankClicked} alt="Checkbox Icon" />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  onClick={async () => {
                    setSelectedTin("no");
                    let kycQuestionaire =
                      JSON.parse(
                        localStorage.getItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                        ),
                      ) || {};
                    kycQuestionaire[isSec ? "selectedTinSec" : "selectedTin"] =
                      await encryptKycString("no");

                    setKycQuestionnaire((prev) =>
                      isSec
                        ? {
                            ...prev,
                            selectedTinSec: "no",
                          }
                        : { ...prev, selectedTin: "no" },
                    );
                    localStorage.setItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                      JSON.stringify({
                        ...kycQuestionaire,
                        lastUpdated: Date.now(),
                      }),
                    );
                  }}
                  className="select-bank-popup-body-content"
                >
                  <div className="select-bank-popup-body-content-container">
                    <div className="select-bank-popup-body-content-main">
                      <div className="select-bank-popup-body-content-text-container">
                        <p className="select-bank-popup-body-content-text">
                          {t("kyc.no")}
                        </p>
                      </div>
                      {selectedTin !== "no" && (
                        <img src={selectBankCircle} alt="Checkbox Icon" />
                      )}
                      {selectedTin === "no" && (
                        <img src={selectBankClicked} alt="Checkbox Icon" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedTin === "yes" && (
        <React.Fragment>
          <p className="verify-kyc-footer-text">
            {t("placeholder.tinEquivalent")}
          </p>

          <div className="profile-edit-contact-body">
            <input
              name="tin-input"
              style={{
                border: "1px solid var(--Neutral-100, #eeeef0)",
                background: "transparent",
                fontWeight: "600",
              }}
              onInput={async (e) => {
                setInputTin(e?.target?.value);
                let kycQuestionaire =
                  JSON.parse(
                    localStorage.getItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                    ),
                  ) || {};

                kycQuestionaire["inputTin"] = await encryptKycString(
                  e?.target?.value,
                );

                setKycQuestionnaire((prev) => ({
                  ...prev,
                  inputTin: e?.target?.value,
                }));
                localStorage.setItem(
                  `${userAddress?.toLowerCase()}-kyc-aml`,
                  JSON.stringify({
                    ...kycQuestionaire,
                    lastUpdated: Date.now(),
                  }),
                );
              }}
              value={inputTin}
              type="text"
              className="offer-security-popup-input"
              placeholder={t("placeholder.tinEquivalent")}
            />
          </div>
        </React.Fragment>
      )}

      {selectedTin === "no" && (
        <React.Fragment>
          <p className="verify-kyc-footer-text">
            {t("kyc.noTinJustification")}
          </p>

          <div className="profile-edit-contact-body">
            <div className="select-bank-popup">
              <div className="select-bank-popup-container">
                <div className="select-bank-popup-body">
                  <div className="select-bank-popup-body-container">
                    <div
                      onClick={async () => {
                        setSelectedNoTin(
                          "The country of residence does not issue TIN's",
                        );
                        let kycQuestionaire =
                          JSON.parse(
                            localStorage.getItem(
                              `${userAddress?.toLowerCase()}-kyc-aml`,
                            ),
                          ) || {};
                        kycQuestionaire[
                          isSec ? "selectedNoTinSec" : "selectedNoTin"
                        ] = await encryptKycString(
                          "The country of residence does not issue TIN's",
                        );

                        setKycQuestionnaire((prev) =>
                          isSec
                            ? {
                                ...prev,
                                selectedNoTinSec:
                                  "The country of residence does not issue TIN's",
                              }
                            : {
                                ...prev,
                                selectedNoTin:
                                  "The country of residence does not issue TIN's",
                              },
                        );
                        localStorage.setItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                          JSON.stringify({
                            ...kycQuestionaire,
                            lastUpdated: Date.now(),
                          }),
                        );
                      }}
                      className="select-bank-popup-body-content"
                    >
                      <div className="select-bank-popup-body-content-container">
                        <div className="select-bank-popup-body-content-main">
                          <div className="select-bank-popup-body-content-text-container">
                            <p
                              style={{ maxWidth: "300px" }}
                              className="select-bank-popup-body-content-text"
                            >
                              {t("kyc.countryDoesNotIssueTin")}
                            </p>
                          </div>
                          {selectedNoTin !==
                            "The country of residence does not issue TIN's" && (
                            <img src={selectBankCircle} alt="Checkbox Icon" />
                          )}
                          {selectedNoTin ===
                            "The country of residence does not issue TIN's" && (
                            <img src={selectBankClicked} alt="Checkbox Icon" />
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      onClick={async () => {
                        setSelectedNoTin(
                          "It is impossible for the above mentioned Client to obtain a TIN for the following reason",
                        );
                        let kycQuestionaire =
                          JSON.parse(
                            localStorage.getItem(
                              `${userAddress?.toLowerCase()}-kyc-aml`,
                            ),
                          ) || {};
                        kycQuestionaire[
                          isSec ? "selectedNoTinSec" : "selectedNoTin"
                        ] = await encryptKycString(
                          "It is impossible for the above mentioned Client to obtain a TIN for the following reason",
                        );

                        setKycQuestionnaire((prev) =>
                          isSec
                            ? {
                                ...prev,
                                selectedNoTinSec:
                                  "It is impossible for the above mentioned Client to obtain a TIN for the following reason",
                              }
                            : {
                                ...prev,
                                selectedNoTin:
                                  "It is impossible for the above mentioned Client to obtain a TIN for the following reason",
                              },
                        );
                        localStorage.setItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                          JSON.stringify({
                            ...kycQuestionaire,
                            lastUpdated: Date.now(),
                          }),
                        );
                      }}
                      className="select-bank-popup-body-content"
                    >
                      <div className="select-bank-popup-body-content-container">
                        <div className="select-bank-popup-body-content-main">
                          <div className="select-bank-popup-body-content-text-container">
                            <p
                              style={{ maxWidth: "300px" }}
                              className="select-bank-popup-body-content-text"
                            >
                              {t("kyc.impossibleToObtainTin")}
                            </p>
                          </div>
                          {selectedNoTin !==
                            "It is impossible for the above mentioned Client to obtain a TIN for the following reason" && (
                            <img src={selectBankCircle} alt="Checkbox Icon" />
                          )}
                          {selectedNoTin ===
                            "It is impossible for the above mentioned Client to obtain a TIN for the following reason" && (
                            <img src={selectBankClicked} alt="Checkbox Icon" />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {selectedNoTin ===
            "It is impossible for the above mentioned Client to obtain a TIN for the following reason" && (
            <React.Fragment>
              <p className="verify-kyc-footer-text">
                {t("kyc.provideReasonForNoTin")}
              </p>
              <div className="profile-edit-contact-body">
                <textarea
                  name="pep-input"
                  style={{
                    border: "1px solid var(--Neutral-100, #eeeef0)",
                    background: "transparent",
                    fontWeight: "500",
                    minHeight: "50px",
                    width: "100%",
                  }}
                  value={inputNoTin}
                  onInput={async (e) => {
                    setInputNoTin(e?.target?.value);
                    let kycQuestionaire =
                      JSON.parse(
                        localStorage.getItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                        ),
                      ) || {};
                    kycQuestionaire[isSec ? "inputNoTinSec" : "inputNoTin"] =
                      await encryptKycString(e?.target?.value);

                    setKycQuestionnaire((prev) =>
                      isSec
                        ? {
                            ...prev,
                            inputNoTinSec: e?.target?.value,
                          }
                        : { ...prev, inputNoTin: e?.target?.value },
                    );
                    localStorage.setItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                      JSON.stringify({
                        ...kycQuestionaire,
                        lastUpdated: Date.now(),
                      }),
                    );
                  }}
                  type="text"
                  className="offer-security-popup-input"
                  placeholder={t("placeholder.noTinReason")}
                ></textarea>
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export const UploadDocumentOverlay = (props) => {
  const { t } = useTranslation();
  const {
    uploadedDocument,
    setUploadedDocument,
    setUploadedDocumentHash,
    uploadPercentage,
    setUploadPercentage,
    fileTypes,
    fileTypesText,
    inputTagId,
    inputTagIdSec,
    hashKycName,
    docKycName,
    setKycQuestionaire,
  } = props;

  const { userAddress } = useUserStore();

  return (
    <div className="offer-security-popup-body-second-body">
      <input
        onInputCapture={(e) => {
          const fileToUpload = e.target.files[0];
          setUploadedDocument(fileToUpload);

          setUploadedDocumentHash(null);
        }}
        onInput={async (e) => {
          const fileToUpload = e.target.files[0];

          //upload file to firebase

          //reset the value after capture to trigger onInput everytime
          e.target.value = "";
          //upload file to ipfs
          await uploadFileToFirebase(
            hashTheString(userAddress),
            fileToUpload,
            fileToUpload?.name,
            setUploadPercentage,
          ).then(async (res) => {
            if (res) {
              setUploadedDocumentHash(res);
              let kycQuestionaire =
                JSON.parse(
                  localStorage.getItem(`${userAddress?.toLowerCase()}-kyc-aml`),
                ) || {};
              kycQuestionaire[hashKycName] = await encryptKycString(res);
              kycQuestionaire[docKycName] = {
                name: fileToUpload?.name,
                size: fileToUpload?.size,
              };

              setKycQuestionaire((prev) => ({
                ...prev,
                [hashKycName]: res,
                [docKycName]: {
                  name: fileToUpload?.name,
                  size: fileToUpload?.size,
                },
              }));

              localStorage.setItem(
                `${userAddress?.toLowerCase()}-kyc-aml`,
                JSON.stringify({
                  ...kycQuestionaire,
                  lastUpdated: Date.now(),
                }),
              );
            }
          });
        }}
        className="offer-security-popup-body-second-input"
        type="file"
        accept={fileTypes || ""}
        name="offer-document"
        id={inputTagIdSec}
      />
      {uploadedDocument && uploadedDocument?.name && uploadedDocument?.size && (
        <div className="offer-security-popup-body-second-body-file-container">
          <div className="offer-security-popup-body-second-body-file-content">
            <div className="offer-security-popup-body-second-body-file-header">
              <img src={documentIcon} alt="Document Icon" />
              <div className="offer-security-popup-body-second-body-file-text-container">
                <p className="offer-security-popup-body-second-body-file-title">
                  {uploadedDocument.name}
                </p>
                <p className="offer-security-popup-body-second-body-file-text">
                  {formatFileSize(uploadedDocument.size)}
                </p>
              </div>
              <img
                onClick={() => {
                  setUploadedDocument(null);
                }}
                src={popupCloseIcon}
                alt="Document Icon"
              />
            </div>

            <div className="offer-security-popup-body-second-body-file-footer">
              <div className="offer-security-popup-body-second-body-file-footer-container">
                <div className="offer-security-popup-body-second-body-file-line-outer">
                  <div
                    style={{ width: `${uploadPercentage}%` }}
                    className="offer-security-popup-body-second-body-file-line-inner"
                  ></div>
                </div>
              </div>
              <p className="offer-security-popup-body-second-body-file-footer-text">
                {uploadPercentage}%
              </p>
            </div>
          </div>
        </div>
      )}

      <div
        id={inputTagId}
        onClick={() => {
          const fileInput = document.getElementById(inputTagIdSec);
          if (fileInput) {
            fileInput.click();
          }
        }}
        onDropCapture={(e) => {
          e.preventDefault();
          const files = e.dataTransfer.files;
          if (files.length > 0) {
            setUploadedDocument(files[0]);

            setUploadedDocumentHash(null);
          }
          const inputContainerTag = document.getElementsByClassName(
            "offer-security-popup-body-second-body-container-drop",
          );
          if (inputContainerTag[0]) {
            inputContainerTag[0].className =
              "offer-security-popup-body-second-body-container";
          }
        }}
        onDrop={async (e) => {
          const fileToUpload = e.dataTransfer.files[0];

          //upload file to firebase
          await uploadFileToFirebase(
            hashTheString(userAddress),
            fileToUpload,
            fileToUpload?.name,
            setUploadPercentage,
          ).then(async (res) => {
            if (res) {
              setUploadedDocumentHash(res);
              let kycQuestionaire =
                JSON.parse(
                  localStorage.getItem(`${userAddress?.toLowerCase()}-kyc-aml`),
                ) || {};
              kycQuestionaire[hashKycName] = await encryptKycString(res);
              kycQuestionaire[docKycName] = {
                name: fileToUpload?.name,
                size: fileToUpload?.size,
              };

              setKycQuestionaire((prev) => ({
                ...prev,
                [hashKycName]: res,
                [docKycName]: {
                  name: fileToUpload?.name,
                  size: fileToUpload?.size,
                },
              }));

              localStorage.setItem(
                `${userAddress?.toLowerCase()}-kyc-aml`,
                JSON.stringify({
                  ...kycQuestionaire,
                  lastUpdated: Date.now(),
                }),
              );
            }
          });
        }}
        onDragOver={(e) => {
          e.preventDefault();
          const inputContainerTag = document.getElementById(inputTagId);
          if (inputContainerTag) {
            inputContainerTag.className =
              "offer-security-popup-body-second-body-container-drop";
          }
        }}
        onDragLeave={() => {
          const inputContainerTag = document.getElementsByClassName(
            "offer-security-popup-body-second-body-container-drop",
          );
          if (inputContainerTag[0]) {
            inputContainerTag[0].className =
              "offer-security-popup-body-second-body-container";
          }
        }}
        className="offer-security-popup-body-second-body-container"
      >
        <div className="offer-security-popup-body-second-body-icon">
          <img src={fileCopyIcon} alt="Copy Icon" />
        </div>
        <div
          style={{ maxWidth: "300px", gap: "10px" }}
          className="offer-security-popup-body-second-body-text-container"
        >
          <p
            style={{ minWidth: "fit-content" }}
            className="offer-security-popup-body-second-body-first-text"
          >
            {t("kyc.clickToUpload")}
          </p>
          <p className="offer-security-popup-body-second-body-second-text">
            or drag and drop a {fileTypesText}
          </p>
        </div>
      </div>
    </div>
  );
};

export const UploadDocumentOverlayPartner = (props) => {
  const {
    uploadedDocument,
    setUploadedDocument,
    setUploadedDocumentHash,
    uploadPercentage,
    setUploadPercentage,
    fileTypes,
    fileTypesText,
    inputTagId,
    inputTagIdSec,
    hashKycName,
    docKycName,
    setKycQuestionaire,
    partnersDetails,
    setPartnersDetails,
    partnerIdx,
  } = props;

  const { userAddress } = useUserStore();

  return (
    <div className="offer-security-popup-body-second-body">
      <input
        onInputCapture={(e) => {
          const fileToUpload = e.target.files[0];
          setUploadedDocument(fileToUpload);

          setUploadedDocumentHash(null);
        }}
        onInput={async (e) => {
          const fileToUpload = e.target.files[0];

          //upload file to firebase

          //reset the value after capture to trigger onInput everytime
          e.target.value = "";
          //upload file to ipfs
          await uploadFileToFirebase(
            hashTheString(userAddress),
            fileToUpload,
            fileToUpload?.name,
            setUploadPercentage,
          ).then(async (res) => {
            if (res) {
              setUploadedDocumentHash(res);
              // let kycQuestionaire =
              //   JSON.parse(
              //     localStorage.getItem(
              //       `${userAddress?.toLowerCase()}-kyc-aml`,
              //     ),
              //   ) || {};
              // kycQuestionaire[hashKycName] = await encryptKycString(res);
              // kycQuestionaire[docKycName] = {
              //   name: uploadedDocument?.name,
              //   size: uploadedDocument?.size,
              // };

              let newPartners = partnersDetails;
              newPartners[partnerIdx] = {
                ...newPartners[partnerIdx],
                [docKycName]: {
                  name: fileToUpload?.name,
                  size: fileToUpload?.size,
                },

                [hashKycName]: res,
              };
              setPartnersDetails(newPartners);
              setKycQuestionaire((prev) => ({
                ...prev,
                partnersDetails: newPartners,
              }));

              // localStorage.setItem(
              //   `${userAddress?.toLowerCase()}-kyc-aml`,
              //   JSON.stringify({
              //     ...kycQuestionaire,
              //     lastUpdated: Date.now(),
              //   }),
              // );
            }
          });
        }}
        className="offer-security-popup-body-second-input"
        type="file"
        accept={fileTypes || ""}
        name="offer-document"
        id={inputTagIdSec}
      />
      {partnersDetails[partnerIdx] &&
        partnersDetails[partnerIdx][docKycName] && (
          <div className="offer-security-popup-body-second-body-file-container">
            <div className="offer-security-popup-body-second-body-file-content">
              <div className="offer-security-popup-body-second-body-file-header">
                <img src={documentIcon} alt="Document Icon" />
                <div className="offer-security-popup-body-second-body-file-text-container">
                  <p className="offer-security-popup-body-second-body-file-title">
                    {partnersDetails[partnerIdx][docKycName]?.name}
                  </p>
                  <p className="offer-security-popup-body-second-body-file-text">
                    {formatFileSize(
                      partnersDetails[partnerIdx][docKycName]?.size,
                    )}
                  </p>
                </div>
                <img
                  onClick={() => {
                    let partnerDt = [...partnersDetails];

                    partnerDt[partnerIdx][docKycName] = null;

                    setPartnersDetails(partnerDt);
                  }}
                  src={popupCloseIcon}
                  alt="Document Icon"
                />
              </div>

              <div className="offer-security-popup-body-second-body-file-footer">
                <div className="offer-security-popup-body-second-body-file-footer-container">
                  <div className="offer-security-popup-body-second-body-file-line-outer">
                    <div
                      style={{ width: "100%" }}
                      className="offer-security-popup-body-second-body-file-line-inner"
                    ></div>
                  </div>
                </div>
                <p className="offer-security-popup-body-second-body-file-footer-text">
                  100%
                </p>
              </div>
            </div>
          </div>
        )}

      {!partnersDetails[partnerIdx] ||
        (!partnersDetails[partnerIdx][docKycName] && (
          <React.Fragment>
            {uploadedDocument &&
              uploadedDocument?.name &&
              uploadedDocument?.size && (
                <div className="offer-security-popup-body-second-body-file-container">
                  <div className="offer-security-popup-body-second-body-file-content">
                    <div className="offer-security-popup-body-second-body-file-header">
                      <img src={documentIcon} alt="Document Icon" />
                      <div className="offer-security-popup-body-second-body-file-text-container">
                        <p className="offer-security-popup-body-second-body-file-title">
                          {uploadedDocument.name}
                        </p>
                        <p className="offer-security-popup-body-second-body-file-text">
                          {formatFileSize(uploadedDocument.size)}
                        </p>
                      </div>
                      <img
                        onClick={() => {
                          setUploadedDocument(null);
                        }}
                        src={popupCloseIcon}
                        alt="Document Icon"
                      />
                    </div>

                    <div className="offer-security-popup-body-second-body-file-footer">
                      <div className="offer-security-popup-body-second-body-file-footer-container">
                        <div className="offer-security-popup-body-second-body-file-line-outer">
                          <div
                            style={{ width: `${uploadPercentage}%` }}
                            className="offer-security-popup-body-second-body-file-line-inner"
                          ></div>
                        </div>
                      </div>
                      <p className="offer-security-popup-body-second-body-file-footer-text">
                        {uploadPercentage}%
                      </p>
                    </div>
                  </div>
                </div>
              )}
          </React.Fragment>
        ))}

      <div
        id={inputTagId}
        onClick={() => {
          const fileInput = document.getElementById(inputTagIdSec);
          if (fileInput) {
            fileInput.click();
          }
        }}
        onDropCapture={(e) => {
          e.preventDefault();
          const files = e.dataTransfer.files;
          if (files.length > 0) {
            setUploadedDocument(files[0]);

            setUploadedDocumentHash(null);
          }
          const inputContainerTag = document.getElementsByClassName(
            "offer-security-popup-body-second-body-container-drop",
          );
          if (inputContainerTag[0]) {
            inputContainerTag[0].className =
              "offer-security-popup-body-second-body-container";
          }
        }}
        onDrop={async (e) => {
          const fileToUpload = e.dataTransfer.files[0];

          //upload file to firebase
          await uploadFileToFirebase(
            hashTheString(userAddress),
            fileToUpload,
            fileToUpload?.name,
            setUploadPercentage,
          ).then(async (res) => {
            if (res) {
              setUploadedDocumentHash(res);
              // let kycQuestionaire =
              //   JSON.parse(
              //     localStorage.getItem(
              //       `${userAddress?.toLowerCase()}-kyc-aml`,
              //     ),
              //   ) || {};
              // kycQuestionaire[hashKycName] = await encryptKycString(res);
              // kycQuestionaire[docKycName] = {
              //   name: uploadedDocument?.name,
              //   size: uploadedDocument?.size,
              // };

              let newPartners = partnersDetails;
              newPartners[partnerIdx] = {
                ...newPartners[partnerIdx],
                [docKycName]: {
                  name: fileToUpload?.name,
                  size: fileToUpload?.size,
                },

                [hashKycName]: res,
              };
              setPartnersDetails(newPartners);
              setKycQuestionaire((prev) => ({
                ...prev,
                partnersDetails: newPartners,
              }));

              // localStorage.setItem(
              //   `${userAddress?.toLowerCase()}-kyc-aml`,
              //   JSON.stringify({
              //     ...kycQuestionaire,
              //     lastUpdated: Date.now(),
              //   }),
              // );
            }
          });
        }}
        onDragOver={(e) => {
          e.preventDefault();
          const inputContainerTag = document.getElementById(inputTagId);
          if (inputContainerTag) {
            inputContainerTag.className =
              "offer-security-popup-body-second-body-container-drop";
          }
        }}
        onDragLeave={() => {
          const inputContainerTag = document.getElementsByClassName(
            "offer-security-popup-body-second-body-container-drop",
          );
          if (inputContainerTag[0]) {
            inputContainerTag[0].className =
              "offer-security-popup-body-second-body-container";
          }
        }}
        className="offer-security-popup-body-second-body-container"
      >
        <div className="offer-security-popup-body-second-body-icon">
          <img src={fileCopyIcon} alt="Copy Icon" />
        </div>
        <div
          style={{ maxWidth: "300px", gap: "10px" }}
          className="offer-security-popup-body-second-body-text-container"
        >
          <p
            style={{ minWidth: "fit-content" }}
            className="offer-security-popup-body-second-body-first-text"
          >
            Click to Upload
          </p>
          <p className="offer-security-popup-body-second-body-second-text">
            or drag and drop a {fileTypesText}
          </p>
        </div>
      </div>
    </div>
  );
};

export const UploadDocumentOverlayMultiple = (props) => {
  const {
    fileTypes,
    fileTypesText,
    inputTagId,
    inputTagIdSec,
    hashKycName,
    docKycName,
    setKycQuestionaire,
    isMultiple,
    uploadedDocuments,
    setUploadedDocuments,
    uploadedDocumentsHash,
    setUploadedDocumentsHash,
    uploadPercentages,
    setUploadPercentages,
  } = props;

  const { userAddress } = useUserStore();

  return (
    <div className="offer-security-popup-body-second-body">
      <input
        // onInputCapture={(e) => {
        //   const fileToUpload = e.target.files[0];
        //    setUploadedDocuments(uploadedDocuments.push(fileToUpload));

        //     setUploadedDocumentsHash([]);

        //     console.log("one settig multiple...", fileToUpload);
        // }}
        onInput={async (e) => {
          const fileToUpload = e.target.files[0];
          setUploadedDocuments([...uploadedDocuments, fileToUpload]);

          //upload file to firebase

          //reset the value after capture to trigger onInput everytime
          e.target.value = "";
          //upload file to ipfs
          await uploadFileToFirebase(
            hashTheString(userAddress),
            fileToUpload,
            fileToUpload?.name,
            setUploadPercentages,
            uploadedDocuments.length,
            uploadPercentages,
          ).then(async (res) => {
            if (res) {
              setUploadedDocumentsHash([...uploadedDocumentsHash, res]);
              let kycQuestionaire =
                JSON.parse(
                  localStorage.getItem(`${userAddress?.toLowerCase()}-kyc-aml`),
                ) || {};
              let prevHashName = kycQuestionaire[hashKycName] || [];
              let prevDocKycName = kycQuestionaire[docKycName] || [];
              if (!Array.isArray(prevHashName)) {
                prevHashName = [prevHashName];
              }
              if (!Array.isArray(prevDocKycName)) {
                prevDocKycName = [prevDocKycName];
              }

              const _prevHashName = flattenArray(prevHashName);

              const _prevDocKycName = flattenArray(prevDocKycName);

              kycQuestionaire[hashKycName] = [
                ..._prevHashName,
                await encryptKycString(res),
              ];

              kycQuestionaire[docKycName] = [
                ..._prevDocKycName,
                {
                  name: fileToUpload?.name,
                  size: fileToUpload?.size,
                },
              ];

              setKycQuestionaire((prev) => {
                let prevHashKycName = prev[hashKycName] || [];
                let prevDocKycName = prev[docKycName] || [];

                if (!Array.isArray(prevHashKycName)) {
                  prevHashKycName = [prevHashKycName];
                }
                if (!Array.isArray(prevDocKycName)) {
                  prevDocKycName = [prevDocKycName];
                }

                const _prevHashKycName = flattenArray(prevHashKycName);

                const _prevDocKycName = flattenArray(prevDocKycName);

                return {
                  ...prev,
                  [hashKycName]: [..._prevHashKycName, res],
                  [docKycName]: [
                    ..._prevDocKycName,
                    {
                      name: fileToUpload?.name,
                      size: fileToUpload?.size,
                    },
                  ],
                };
              });

              localStorage.setItem(
                `${userAddress?.toLowerCase()}-kyc-aml`,
                JSON.stringify({
                  ...kycQuestionaire,
                  lastUpdated: Date.now(),
                }),
              );
            }
          });
        }}
        className="offer-security-popup-body-second-input"
        type="file"
        accept={fileTypes || ""}
        name="offer-document"
        id={inputTagIdSec}
      />

      {uploadedDocuments?.length > 0 && (
        <React.Fragment>
          {uploadedDocuments.map((dcm, idx) => (
            <React.Fragment>
              {dcm?.name && dcm?.size && (
                <div
                  key={`upload-documents-tx-${idx}`}
                  className="offer-security-popup-body-second-body-file-container"
                >
                  <div className="offer-security-popup-body-second-body-file-content">
                    <div className="offer-security-popup-body-second-body-file-header">
                      <img src={documentIcon} alt="Document Icon" />
                      <div className="offer-security-popup-body-second-body-file-text-container">
                        <p className="offer-security-popup-body-second-body-file-title">
                          {dcm.name}
                        </p>
                        <p className="offer-security-popup-body-second-body-file-text">
                          {formatFileSize(dcm.size)}
                        </p>
                      </div>
                      {uploadPercentages &&
                        Number(uploadPercentages[idx]) === 100 && (
                          <img
                            onClick={() => {
                              const newDocuments = uploadedDocuments?.filter(
                                (_dcm) => _dcm !== dcm,
                              );

                              setUploadedDocuments(newDocuments);
                              const newPerc =
                                newDocuments?.length > 0
                                  ? new Array(newDocuments?.length).fill(100)
                                  : [0];
                              setUploadPercentages(newPerc);
                            }}
                            src={popupCloseIcon}
                            alt="Document Icon"
                          />
                        )}
                    </div>

                    <div className="offer-security-popup-body-second-body-file-footer">
                      <div className="offer-security-popup-body-second-body-file-footer-container">
                        <div className="offer-security-popup-body-second-body-file-line-outer">
                          <div
                            style={{
                              width: `${uploadPercentages ? uploadPercentages[idx] : 0}%`,
                            }}
                            className="offer-security-popup-body-second-body-file-line-inner"
                          ></div>
                        </div>
                      </div>
                      <p className="offer-security-popup-body-second-body-file-footer-text">
                        {uploadPercentages?.length > 0
                          ? uploadPercentages[idx]
                          : 0.0}
                        %
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </React.Fragment>
      )}
      <div
        id={inputTagId}
        onClick={() => {
          const fileInput = document.getElementById(inputTagIdSec);
          if (fileInput) {
            fileInput.click();
          }
        }}
        // onDropCapture={(e) => {
        //   e.preventDefault();
        //   const files = e.dataTransfer.files;
        //   if (files.length > 0) {
        //     if (isMultiple) {
        //       setUploadedDocumentsHash([]);
        //       setUploadedDocuments(uploadedDocuments.push(files[0]));

        //       setUploadedDocumentsHash([]);
        //     } else {
        //       setUploadedDocument(files[0]);

        //       setUploadedDocumentHash(null);
        //     }
        //   }
        //   const inputContainerTag = document.getElementsByClassName(
        //     "offer-security-popup-body-second-body-container-drop",
        //   );
        //   if (inputContainerTag[0]) {
        //     inputContainerTag[0].className =
        //       "offer-security-popup-body-second-body-container";
        //   }
        // }}
        onDrop={async (e) => {
          const fileToUpload = e.dataTransfer.files[0];
          setUploadedDocuments([...uploadedDocuments, fileToUpload]);

          //upload file to firebase
          await uploadFileToFirebase(
            hashTheString(userAddress),
            fileToUpload,
            fileToUpload?.name,
            setUploadPercentages,
            uploadedDocuments.length,
            uploadPercentages,
          ).then(async (res) => {
            if (res) {
              setUploadedDocumentsHash([...uploadedDocumentsHash, res]);
              let kycQuestionaire =
                JSON.parse(
                  localStorage.getItem(`${userAddress?.toLowerCase()}-kyc-aml`),
                ) || {};
              let prevHashName = kycQuestionaire[hashKycName] || [];
              let prevDocKycName = kycQuestionaire[docKycName] || [];
              if (!Array.isArray(prevHashName)) {
                prevHashName = [prevHashName];
              }
              if (!Array.isArray(prevDocKycName)) {
                prevDocKycName = [prevDocKycName];
              }

              const _prevHashName = flattenArray(prevHashName);

              const _prevDocKycName = flattenArray(prevDocKycName);

              kycQuestionaire[hashKycName] = [
                ..._prevHashName,
                await encryptKycString(res),
              ];

              kycQuestionaire[docKycName] = [
                ..._prevDocKycName,
                {
                  name: fileToUpload?.name,
                  size: fileToUpload?.size,
                },
              ];

              setKycQuestionaire((prev) => {
                let prevHashKycName = prev[hashKycName] || [];
                let prevDocKycName = prev[docKycName] || [];

                if (!Array.isArray(prevHashKycName)) {
                  prevHashKycName = [prevHashKycName];
                }
                if (!Array.isArray(prevDocKycName)) {
                  prevDocKycName = [prevDocKycName];
                }

                const _prevHashKycName = flattenArray(prevHashKycName);

                const _prevDocKycName = flattenArray(prevDocKycName);

                return {
                  ...prev,
                  [hashKycName]: [..._prevHashKycName, res],
                  [docKycName]: [
                    ..._prevDocKycName,
                    {
                      name: fileToUpload?.name,
                      size: fileToUpload?.size,
                    },
                  ],
                };
              });

              localStorage.setItem(
                `${userAddress?.toLowerCase()}-kyc-aml`,
                JSON.stringify({
                  ...kycQuestionaire,
                  lastUpdated: Date.now(),
                }),
              );
            }
          });
        }}
        onDragOver={(e) => {
          e.preventDefault();
          const inputContainerTag = document.getElementById(inputTagId);
          if (inputContainerTag) {
            inputContainerTag.className =
              "offer-security-popup-body-second-body-container-drop";
          }
        }}
        onDragLeave={() => {
          const inputContainerTag = document.getElementsByClassName(
            "offer-security-popup-body-second-body-container-drop",
          );
          if (inputContainerTag[0]) {
            inputContainerTag[0].className =
              "offer-security-popup-body-second-body-container";
          }
        }}
        className="offer-security-popup-body-second-body-container"
      >
        <div className="offer-security-popup-body-second-body-icon">
          <img src={fileCopyIcon} alt="Copy Icon" />
        </div>
        <div
          style={{ maxWidth: "300px", gap: "10px" }}
          className="offer-security-popup-body-second-body-text-container"
        >
          <p
            style={{ minWidth: "fit-content" }}
            className="offer-security-popup-body-second-body-first-text"
          >
            Click to Upload
          </p>
          <p className="offer-security-popup-body-second-body-second-text">
            or drag and drop a {fileTypesText}
          </p>
        </div>
      </div>
    </div>
  );
};

export const StructureFlowApplicantNode = ({ data }) => {
  return (
    <div className="kycQuestionnaire-new-layout-structure-flow-app-container">
      <div className="kycQuestionnaire-new-layout-structure-flow-app-text-cont">
        <div className="kycQuestionnaire-new-layout-structure-flow-app-text-content">
          <p className="kycQuestionnaire-new-layout-structure-flow-app-text">
            {data.name}
          </p>
          <div className="kycQuestionnaire-new-layout-structure-flow-app-button">
            Applicant
          </div>
        </div>
      </div>

      <img
        className="kycQuestionnaire-new-layout-structure-flow-app-icon"
        src={addGreyIcon}
        alt="add icon"
        onClick={() => {
          if (data?.showNodeForm) {
            data?.showNodeForm("0");
          }
        }}
      />

      <Handle
        type="target"
        position={Position.Top}
        id={`${data?.name}-${Date.now()}`}
        style={{ opacity: 0, pointerEvents: "none" }}
      />
    </div>
  );
};

export const StructureFlowApplicantAddNode = ({ data }) => {
  return (
    <div
      onClick={() => {
        if (data?.showNodeForm) {
          data?.showNodeForm("0");
        }
      }}
      className="kycQuestionnaire-new-layout-structure-flow-app-add-container"
    >
      <div className="kycQuestionnaire-new-layout-structure-flow-app-add-text-cont">
        <img
          className="kycQuestionnaire-new-layout-structure-flow-app-add-icon"
          src={plusGreyIcon}
          alt="add icon"
        />
        <p className="kycQuestionnaire-new-layout-structure-flow-app-add-text">
          Add Controlling Entity
        </p>
      </div>
    </div>
  );
};

export const StructureFlowApplicantAddNodeForm = ({ data }) => {
  return (
    <div
      className={
        data?.isSaved
          ? "kycQuestionnaire-new-layout-structure-flow-app-container"
          : "kycQuestionnaire-new-layout-structure-flow-app-add-form-container"
      }
    >
      <div
        onClick={() => {
          if (data?.showNodeFormClicked && data?.id) {
            data?.showNodeFormClicked(data?.id?.replace("n", ""));
          }
        }}
        className="kycQuestionnaire-new-layout-structure-flow-app-add-form"
      >
        <div className="kycQuestionnaire-new-layout-structure-flow-app-add-form-header">
          <p
            className={
              data?.isSaved && data?.name && data?.name !== ""
                ? "kycQuestionnaire-new-layout-structure-flow-app-text"
                : "kycQuestionnaire-new-layout-structure-flow-app-add-form-header-text"
            }
          >
            {data?.isSaved && data?.name
              ? data?.name
              : !data?.isSaved && data?.isExisting && data?.old?.name
                ? data?.old?.name
                : "Enter Entity Name"}
          </p>

          <div className="kycQuestionnaire-new-layout-structure-flow-app-add-form-header-label-cont">
            <p className="kycQuestionnaire-new-layout-structure-flow-app-add-form-header-label">
              {data?.isSaved && data?.type
                ? data?.type
                : !data?.isSaved && data?.isExisting && data?.old?.type
                  ? data?.old?.type
                  : "Type"}
            </p>
          </div>
        </div>

        <div className="kycQuestionnaire-new-layout-structure-flow-app-add-form-body">
          <div className="kycQuestionnaire-new-layout-structure-flow-app-add-form-body-text-cont">
            <p className="kycQuestionnaire-new-layout-structure-flow-app-add-form-body-text">
              Ownership{" "}
            </p>
            <p
              className={
                data?.isSaved &&
                data?.ownershipPerc &&
                data?.ownershipPerc !== ""
                  ? "kycQuestionnaire-new-layout-structure-flow-app-add-form-body-label-active"
                  : "kycQuestionnaire-new-layout-structure-flow-app-add-form-body-label"
              }
            >
              {data?.isSaved && data?.ownershipPerc
                ? data?.ownershipPerc
                : !data?.isSaved && data?.isExisting && data?.old?.ownershipPerc
                  ? data?.old?.ownershipPerc
                  : "0"}
              %
            </p>
          </div>

          <div className="kycQuestionnaire-new-layout-structure-flow-app-add-form-body-text-cont">
            <p className="kycQuestionnaire-new-layout-structure-flow-app-add-form-body-text">
              Voting Rights{" "}
            </p>
            <p
              className={
                data?.isSaved && data?.votingPerc && data?.votingPerc !== ""
                  ? "kycQuestionnaire-new-layout-structure-flow-app-add-form-body-label-active"
                  : "kycQuestionnaire-new-layout-structure-flow-app-add-form-body-label"
              }
            >
              {data?.isSaved && data?.votingPerc
                ? data?.votingPerc
                : !data?.isSaved && data?.isExisting && data?.old?.votingPerc
                  ? data?.old?.votingPerc
                  : "0"}
              %
            </p>
          </div>
        </div>
      </div>

      <img
        className="kycQuestionnaire-new-layout-structure-flow-app-icon"
        src={data?.isSaved ? addGreyIcon : addBlueIcon}
        alt="add icon"
        onClick={() => {
          if (data?.showNodeForm && data?.id) {
            data?.showNodeForm(data?.id?.replace("n", ""));
          }
        }}
      />

      <Handle
        type="target"
        position={Position.Top}
        id={`${data?.name}-${Date.now()}`}
        style={{ opacity: 0, pointerEvents: "none" }}
      />

      <Handle
        type="source"
        position={Position.Bottom}
        id={`${data?.name}-${Date.now()}`}
        style={{ opacity: 0, pointerEvents: "none" }}
      />
    </div>
  );
};

export const UploadKycDocumentOverlay = (props) => {
  const { userAddress } = useUserStore();
  const { uploadDocument, setUploadedDocument, closeUpload } = props;
  const [fileUploadedLocal, setFileUploadedLocal] = useState(
    uploadDocument || {},
  );

  const handleUploadFile = async (fileToUpload, e) => {
    const setUploadPercentage = (percentage) => {
      setFileUploadedLocal((prev) => ({ ...prev, progress: percentage }));
      setUploadedDocument({
        ...uploadDocument,
        orName: fileToUpload?.name,
        size: fileToUpload?.size,
        progress: percentage,
      });
    };

    if (e) {
      //reset the value after capture for input to trigger onInput everytime
      e.target.value = "";
    }
    await uploadFileToFirebase(
      hashTheString(userAddress),
      fileToUpload,
      uploadDocument?.name,
      setUploadPercentage,
    ).then(async (res) => {
      if (res) {
        setFileUploadedLocal((prev) => ({ ...prev, hash: res }));
        setUploadedDocument({
          ...uploadDocument,
          orName: fileToUpload?.name,
          size: fileToUpload?.size,
          progress: 100,
          hash: res,
        });
        if (closeUpload) {
          closeUpload();
        }
      }
    });
  };

  return (
    <div
      style={{ marginTop: "200px" }}
      className="kycQuestionnaire-new-layout-structure-upload-outter"
    >
      <input
        onInputCapture={(e) => {
          const fileToUpload = e.target.files[0];
          setFileUploadedLocal((prev) => ({
            ...prev,
            orName: fileToUpload?.name,
            size: fileToUpload?.size,
            progress: 0,
          }));
          setUploadedDocument({
            ...uploadDocument,
            orName: fileToUpload?.name,
            size: fileToUpload?.size,
            progress: 0,
          });
        }}
        onInput={async (e) => {
          const fileToUpload = e.target.files[0];
          setFileUploadedLocal((prev) => ({
            ...prev,
            orName: fileToUpload?.name,
            size: fileToUpload?.size,
            progress: 0,
          }));
          setUploadedDocument({
            ...uploadDocument,
            orName: fileToUpload?.name,
            size: fileToUpload?.size,
            progress: 0,
          });
          await handleUploadFile(fileToUpload, e);
        }}
        style={{ cursor: "pointer", display: "none" }}
        type="file"
        accept="application/pdf"
        name="kyc-document-upload"
        id="kyc-document-upload-id"
      />
      <div className="kycQuestionnaire-new-layout-structure-upload-body">
        <p className="kycQuestionnaire-new-layout-structure-upload-body-title">
          Add Document
        </p>

        <div
          onClick={() => {
            const fileInput = document.getElementById("kyc-document-upload-id");
            if (fileInput) {
              fileInput.click();
            }
          }}
          onDropCapture={(e) => {
            e.preventDefault();
            const files = e.dataTransfer.files;
            const fileToUpload = files[0];
            setFileUploadedLocal((prev) => ({
              ...prev,
              orName: fileToUpload?.name,
              size: fileToUpload?.size,
              progress: 0,
            }));
            setUploadedDocument({
              ...uploadDocument,
              orName: fileToUpload?.name,
              size: fileToUpload?.size,
              progress: 0,
            });
            const inputContainerTag = document.getElementsByClassName(
              "kycQuestionnaire-new-layout-structure-upload-body-content-active",
            );
            if (inputContainerTag[0]) {
              inputContainerTag[0].className =
                "kycQuestionnaire-new-layout-structure-upload-body-content";
            }
          }}
          onDrop={async (e) => {
            const files = e.dataTransfer.files;
            const fileToUpload = files[0];
            await handleUploadFile(fileToUpload);
          }}
          onDragOver={(e) => {
            e.preventDefault();
            const inputContainerTag = document.getElementById(
              "kyc-document-drag-id",
            );
            if (inputContainerTag) {
              inputContainerTag.className =
                "kycQuestionnaire-new-layout-structure-upload-body-content-active";
            }
          }}
          onDragLeave={() => {
            const inputContainerTag = document.getElementsByClassName(
              "kycQuestionnaire-new-layout-structure-upload-body-content-active",
            );
            if (inputContainerTag[0]) {
              inputContainerTag[0].className =
                "kycQuestionnaire-new-layout-structure-upload-body-content";
            }
          }}
          className="kycQuestionnaire-new-layout-structure-upload-body-content"
          id="kyc-document-drag-id"
        >
          <img src={fileIconBlue} alt="file icon" />

          <div className="kycQuestionnaire-new-layout-structure-upload-body-content-text-cont">
            <p className="kycQuestionnaire-new-layout-structure-upload-body-content-text">
              Drag and drop a PDF (max 50 MB)
            </p>

            <p className="kycQuestionnaire-new-layout-structure-upload-body-content-label">
              or choose file
            </p>
          </div>
        </div>

        {fileUploadedLocal?.orName?.length > 0 && (
          <div className="kycQuestionnaire-new-layout-structure-upload-body-footer">
            <div className="kycQuestionnaire-new-layout-structure-upload-body-footer-cont">
              <img src={pdfFileIconRed} alt="file icon" />

              <div className="kycQuestionnaire-new-layout-structure-upload-body-footer-body">
                <p className="kycQuestionnaire-new-layout-structure-upload-body-footer-title">
                  {fileUploadedLocal?.orName}
                </p>
                <p className="kycQuestionnaire-new-layout-structure-upload-body-footer-label">
                  {fileUploadedLocal?.progress}% uploaded
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      <img
        onClick={() => {
          if (closeUpload) {
            closeUpload();
          }
        }}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "12px",
          top: "12px",
        }}
        src={cancelXIcon}
        alt="close icon"
      />
    </div>
  );
};

export const KYCSubmit = (props) => {
  return (
    <div
      style={{ marginTop: "200px", position: "relative" }}
      className="kycQuestionnaire-new-layout-ubo-email-outter"
    >
      <div className="kycQuestionnaire-new-layout-ubo-email-header">
        <div className="kycQuestionnaire-new-layout-ubo-email-header-cont">
          <p className="kycQuestionnaire-new-layout-ubo-email-header-title">
            {capitalizeFirstLetter(props?.type || "Applicant")} KYC Submission
            Confirmation
          </p>
          <p className="kycQuestionnaire-new-layout-ubo-email-header-text">
            You are about to submit your{" "}
            {props?.type?.toLowerCase() || "applicant"} KYC for{" "}
            {props?.type?.toLowerCase() === "business"
              ? "entities"
              : "applicants"}{" "}
            listed below. Please double-check that all uploaded documents are
            completely legible and up to date to ensure a smooth and quick
            approval process.
          </p>
          {props.entities?.map((ent, idx) => (
            <p
              id={`ent-dt-lst-${idx}`}
              className="kycQuestionnaire-new-layout-ubo-email-header-label"
            >
              {(idx + 1)?.toString()}. {ent}
            </p>
          ))}

          {props?.erroredEntities?.length > 0 && (
            <React.Fragment>
              <p className="kycQuestionnaire-new-layout-ubo-email-header-text">
                Note: Entities listed below are still pending Verification.
              </p>
              {props.erroredEntities?.map((ent, idx) => (
                <p
                  id={`ent-dt-lst-${idx}`}
                  style={{ color: "#b03e3e" }}
                  className="kycQuestionnaire-new-layout-ubo-email-header-label"
                >
                  {(idx + 1)?.toString()}. {ent}
                </p>
              ))}
            </React.Fragment>
          )}

          <p
            style={{
              fontSize: "12px",
              fontStyle: "italic",
            }}
            className="kycQuestionnaire-new-layout-ubo-email-header-text"
          >
            By clicking submit, you authorize our compliance team to review
            these materials. Processing typically takes 1–2 business days.
          </p>
        </div>
      </div>

      <div
        onClick={async () => {
          if (props.handleSubmit) {
            await props.handleSubmit();
          }
        }}
        className="kycQuestionnaire-new-layout-ubo-email-button"
      >
        Submit
      </div>

      <img
        onClick={() => {
          if (props.closeUpload) {
            props.closeUpload();
          }
        }}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "12px",
          top: "12px",
        }}
        src={cancelXIcon}
        alt="close icon"
      />
    </div>
  );
};

export const KYCDropdown = (props) => {
  return (
    <div
      tabIndex={0}
      onClick={async () => {
        if (props.handleClick) {
          await props.handleClick();
        }
      }}
      key={props?.key}
      className="l-search-result-content-container"
    >
      <div className="l-search-result-content">
        <div className="l-search-result-first-section">
          <div
            style={{ gap: "8px" }}
            className="l-search-result-first-text-container"
          >
            {props?.data?.flag && (
              <div className="profile-edit-contact-selection-icon">
                {props?.data?.flag?.length > 0 && (
                  <img
                    style={{ minHeight: "24px", width: "24px" }}
                    src={props?.data?.flag}
                    alt="icon"
                  />
                )}
              </div>
            )}
            <p className="l-search-result-first-text-title">
              {props?.data?.name}
            </p>
          </div>
          {props?.data.description || props?.data?.code ? (
            <div className="l-search-result-second-text-container">
              <p className="l-search-result-second-text">
                {props?.data.description || props?.data?.code}
              </p>
            </div>
          ) : (
            <React.Fragment></React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};
